import Fuse from 'src/Packages/Plugins/TechDivision.Journal/node_modules/fuse.js'

/**
 * Overrides src/Packages/Plugins/TechDivision.Journal/Resources/Private/App/Utilities/searchInitializationUtility.js
 * The override is registered at /overwriteMapping.js and replaces the original file completely
 */
export const getSearchConfiguration = (allJournals) => {
    return new Fuse(allJournals, {
        keys: [{ name: 'title', weight: 2 }, 'description', { name: 'company', weight: 2 }],
        threshold: 0.3,
        ignoreLocation: true,
    })
}
